import type { FC, ReactNode, RefObject } from 'react'

import Dialog from '@reach/dialog'
import CloseIcon from 'mdi-react/CloseIcon'

import '@reach/dialog/styles.css'
import './styles.scss'

export type ModalVariant = 'narrow' | 'medium' | 'wide'

export const Popup: FC<{
  ariaLabel: string
  children: ReactNode
  className?: string
  isOpen: boolean
  variant?: ModalVariant
  initialFocusRef?: RefObject<unknown>
  onClose?: () => void
}> = ({ children, ariaLabel, className, variant, initialFocusRef, isOpen, onClose }) => (
  <Dialog
    isOpen={isOpen}
    className={`ui-popup ${className || ''} ${variant || ''}`}
    initialFocusRef={initialFocusRef}
    aria-label={ariaLabel}
    onDismiss={onClose}
  >
    {onClose && (
      <button className="close-modal-button" onClick={onClose}>
        <CloseIcon />
      </button>
    )}

    {children}
  </Dialog>
)
